<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/yuce/wxhuizong',title:'外销列表'},{title:'已发货'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="产品编码">
							    <el-input
							            v-model="q.proCode"
							            placeholder="请输入"
							            clearable>
							    </el-input>
							</el-form-item>
							<el-form-item label="产品型号">
							    <el-input
							            v-model="q.proModel"
							            placeholder="请输入"
							            clearable>
							    </el-input>
							</el-form-item>
							<el-form-item label="创建人">
							    <el-input
							            v-model="q.cuname"
							            placeholder="请输入"
							            clearable>
							    </el-input>
							</el-form-item>
							<el-form-item label="　　预测单编号">
							    <el-input
							            v-model="q.id"
							            placeholder="请输入"
							            clearable>
							    </el-input>
							</el-form-item>
						</div>	
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="　　占用订单编号">
									    <el-input
									            v-model="q.orderId"
									            placeholder="请输入"
									            clearable>
									    </el-input>
									</el-form-item>
									<el-form-item label="型号属性">
									    <el-select v-model="q.protype"
									               placeholder="请选择"
									               clearable>
									        <el-option label="自产" value="自产"></el-option>
									        <el-option label="OEM" value="OEM"></el-option>
									    </el-select>
									</el-form-item>
									<el-form-item label="国家名称">
									    <brselectlazy placeholder="请选择"
									                  category="YLCountry_agent"
									                  :v="q.country"
													  v-model="q.country"
													  :multiple="true"
													  collapseTags
									                  clearable>
									    </brselectlazy>
									</el-form-item>
									<el-form-item label="常规或改制" >
									    <brselect
									            category="shifou_dingzhi"
									            :v="q.isSpecific"
									            v-model="q.isSpecific"
									            clearable>
									    </brselect>
									</el-form-item>
								</div>	
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="创建时间" class="timeselect" style="width: 50%;">
									    <el-date-picker 
									    	placeholder="请选择"
									    	v-model="q.cdateBegin"
									    	clearable
									    	type="date"
									    	value-format="yyyy-MM-dd" >
									    </el-date-picker>
									    <span class="w-time-to">至</span>
									    <el-date-picker 
									    	placeholder="请选择"
									    	v-model="q.cdateEnd"
									    	clearable
									    	type="date"
									    	value-format="yyyy-MM-dd" >
									    </el-date-picker>
									</el-form-item>
									<el-form-item label="预测类型">
									    <el-select v-model="q.ycrcode" clearable placeholder="请选择">
									        <el-option
									                v-for="item in ycrlist"
									                :key="item.value"
									                :label="item.label"
									                :value="item.value">
									        </el-option>
									    </el-select>
									</el-form-item>
									<el-form-item label="产品大类">
									    <brselect
									            category="product_level"
									            :v="q.cpdlCode"
									            v-model="q.cpdlCode"
												:multiple="true"
												collapseTags
									            clearable>
									    </brselect>
									</el-form-item>
								</div>	
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="　　预计交货期" class="timeselect" style="width: 50%">
										<el-date-picker
									       	placeholder="请选择"
									       	v-model="q.deliveryDateBegin"
									       	clearable
									       	type="date"
									       	value-format="yyyy-MM-dd" >
									       </el-date-picker>
									        <span class="w-time-to">至</span>
									       <el-date-picker
									       	placeholder="请选择"
									       	v-model="q.deliveryDateEnd"
									       	clearable
									       	type="date"
									       	value-format="yyyy-MM-dd" >
									       </el-date-picker>
									</el-form-item>
									<el-form-item label="　　是否需排产">
									    <el-select v-model="q.isDel"
									               placeholder="请选择"
									               clearable>
									        <el-option label="是" value="1"></el-option>
									        <el-option label="否" value="2"></el-option>
									    </el-select>
									</el-form-item>
									<el-form-item label="　　是否生成采购">
									    <el-select v-model="q.isCg"
									               placeholder="请选择"
									               clearable>
									        <el-option label="是" value="1"></el-option>
									        <el-option label="否" value="2"></el-option>
									    </el-select>
									</el-form-item>
								</div>	
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="审核状态">
										<brselect
												category="report_zhuangt"
												:v="q.forecastStatus"
												v-model="q.forecastStatus"
												:multiple="true"
												collapseTags
												clearable>
										</brselect>
<!--									    <el-select v-model="q.forecastStatus" clearable placeholder="请选择">-->
<!--									        <el-option-->
<!--									                v-for="item in yctype"-->
<!--									                :key="item.value"-->
<!--									                :label="item.label"-->
<!--									                :value="item.value">-->
<!--									        </el-option>-->
<!--									    </el-select>-->
									</el-form-item>
									<el-form-item label="　使用预测订单号">
										<el-input
												v-model="q.orderSap"
												placeholder="请输入"
												clearable>
										</el-input>
									</el-form-item>
<!--									<el-form-item label="库存状态">-->
<!--										<brselect-->
<!--										        category="kucun_status"-->
<!--										        :v="q.stockStatus"-->
<!--										        v-model="q.stockStatus"-->
<!--										        clearable>-->
<!--										</brselect>-->
<!--									</el-form-item>-->
								</div>	
							</div>
						</el-collapse-transition>
                        
						<!-- <div class="h-formBtnOut h-columnCenter">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						    <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
						</div> -->
                    </el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
						</div>
					</div>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn ljjinputpadding" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            @selection-change="handleSelectionChange"
                            stripe
                            :border="true"
							max-height="470"
                            style="width: 100%">
                        <el-table-column
                                type="selection"
                                width="40"
                                label="全选">
                        </el-table-column>
                        <el-table-column
                                type="index"
                                fixed
								width="40"
								label="#">
                        </el-table-column>
                        <el-table-column
                                prop="id"
								fixed
                                label="预测单编号"
                                width="160"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="country"
                                label="国家名称"
                                width="90"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="cdate"
                                label="创建时间"
                                width="100"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="cuname"
                                label="创建人"
                                width="80"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="proModel"
                                label="型号"
                                min-width="180"
                                :show-overflow-tooltip="true">
								<template slot-scope="scope">
									<div style="text-align: left;">
										{{scope.row.proModel}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="proCode"
                                width="110"
                                label="产品编码"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="forecastStatus"
                                label="预测状态"
                                width="100"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <dictname category="yuce_zhuangt"  :v="scope.row.forecastStatus"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="schedulingStatus"
                                label="排产状态"
                                width="90"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="proNumber"
                                label="数量"
                                width="60"
                                :show-overflow-tooltip="true">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.proNumber}}
										</div>
									</template>
                        </el-table-column>
						<el-table-column
								prop="totalProduct"
								label="排产数量"
								width="90"
								:show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.totalProduct}}
								</div>
							</template>
						</el-table-column>
                        <el-table-column
                                prop="useNumber"
                                label="可录单数量"
                                width="110"
                                :show-overflow-tooltip="true">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.useNumber}}
										</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="useInventory"
                                width="130"
                                label="使用库存数量">
								<template slot-scope="scope">
									<div style="text-align: right;">
										{{scope.row.useInventory}}
									</div>
								</template>
                        </el-table-column>
						<el-table-column
								prop="scDateB"
								label="生产时间"
								width="160"
								:show-overflow-tooltip="true">
							<template slot-scope="scope">
								{{scope.row.scDateB?scope.row.scDateB:'暂无数据'}}
							</template>
						</el-table-column>
						<el-table-column
								prop="scDateE"
								label="入库时间"
								width="160"
								:show-overflow-tooltip="true">
							<template slot-scope="scope">
								{{scope.row.scDateE?scope.row.scDateE:'暂无数据'}}
							</template>
						</el-table-column>
						<el-table-column
								prop="warehouse"
								label="库龄"
								width="80"
								:show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.warehouse}}
								</div>
							</template>
						</el-table-column>
                        <el-table-column
                                prop="stockStatus"
                                width="90"
                                label="库存状态">
                            <template slot-scope="scope">
                                <dictname category="kucun_status"  :v="scope.row.stockStatus"/>
                            </template>
                        </el-table-column>
						<el-table-column
								prop="cpdlCode"
								label="产品大类"
								width="100"
								:show-overflow-tooltip="true">
							<template slot-scope="scope">
								<dictname category="product_level"  :v="scope.row.cpdlCode"/>
							</template>
						</el-table-column>
						<el-table-column
								prop="protype"
								label="型号属性"
								width="90"
								:show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column
								prop="passDate"
								label="审批通过时间"
								width="160"
								:show-overflow-tooltip="true">
						</el-table-column>
                        <el-table-column
                                prop="isSpecific"
                                width="110"
                                label="常规或改制">
                            <template slot-scope="scope">
                                <dictname category="shifou_dingzhi"  :v="scope.row.isSpecific"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="specificReq"
                                label="改制目录"
                                width="180"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.specificReq}}
                                </div>
                            </template>
                        </el-table-column>
						<el-table-column
								prop="specificReform"
								label="改制要求"
								width="180"
								:show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div style="text-align: left;">
									{{scope.row.specificReform}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="specificRemark"
								label="改制备注"
								width="180"
								:show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div style="text-align: left;">
									{{scope.row.specificRemark}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="reformPriceRmb"
								:show-overflow-tooltip="true"
								width="120"
								label="单台加价(元)">
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.reformPriceRmb}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="productId"
								label="生产订单号"
								width="110"
								:show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column
								prop="totalFinish"
								label="下线数量"
								width="90"
								:show-overflow-tooltip="true">
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.totalFinish}}
								</div>
							</template>
						</el-table-column>
                        <el-table-column
                                prop="remark"
                                label="备注"
                                width="180"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.remark}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="deliveryDate"
                                label="预计交货期"
                                width="110"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="cgCode"
                                label="采购订单号"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
						<el-table-column
								prop="cgSapcode"
								label="SAP采购订单号"
								width="120"
								:show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column
								prop="cgStatus"
								label="采购订单状态"
								width="120"
								:show-overflow-tooltip="true">
							<template slot-scope="scope">
								<dictname category="cg_status"  :v="scope.row.cgStatus"/>
							</template>
						</el-table-column>
                        <el-table-column
                                prop="orderId"
                                label="销售订单号"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
						<el-table-column
								prop="orderSap"
								label="使用预测订单号"
								width="140"
								:show-overflow-tooltip="true">
						</el-table-column>
                        <el-table-column
                                prop="orderStatus"
                                label="销售订单状态"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="shipmentNum"
                                label="销售订单发货数量"
                                width="150"
                                :show-overflow-tooltip="true">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.shipmentNum}}
										</div>
									</template>
                        </el-table-column>
                        
                        <el-table-column
                                fixed="right"
                                width="150"
                                label="操作">
                            <template slot-scope="scope">
                                <div style="display: flex;align-items: center;justify-content: flex-start;">
                                    <el-button
                                            @click="showRow(scope.row.id)"
                                            type="text"
                                            size="small" class="h-tableLink h-btn">查看占用
                                    </el-button>
<!--                                    <el-button-->
<!--                                            v-if="scope.row.showXG"-->
<!--											@click="revise(scope.row.id)"-->
<!--                                            type="text"-->
<!--                                            style="margin-left: 0;"-->
<!--                                            size="small" class="h-tableLink h-btn">修改-->
<!--                                    </el-button>-->
<!--                                    <el-button-->
<!--											v-if="scope.row.showXG"-->
<!--                                            @click="withdraw(scope.row)"-->
<!--                                            type="text"-->
<!--                                            style="margin-left: 0;"-->
<!--                                            size="small" class="h-tableLink h-btn">撤单-->
<!--                                    </el-button>-->
                                    <el-button
                                            size="small" class="h-tableLink h-btn"
                                            v-if="_user.usercode == scope.row.cucode && scope.row.instId"
                                            style="margin-left: 0;"
                                            @click="genzongLiuch(scope.row)">
                                        跟踪
                                    </el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                       @click="exportExcel">批量导出
                            </el-button>
<!--                            <el-button class="h-btn h-formBtn h-bggreen" @click="createOrder" v-if="b == 1">创建采购订单</el-button>-->
                        </div>
                        <div class="h-pagination2 h-pageCenter">
                            <pagination :page="q" @query="handlelist"/>
                        </div>
                    </div>
                </div>
            </div>
            <!--<div class="h-txtCenter h-mrt60">
                &lt;!&ndash;<el-button class="h-btn h-bBtn h-bgwhite" @click="renovate">返回</el-button>&ndash;&gt;
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="reviseInventory" v-auth="'xgkc'">确定修改</el-button>
            </div>-->
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>
<script>

    import ss from '../../../api/SystemService';
    import updownfile from '../../../utils/updownfile'

    export default {
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                ycrlist: [{
                    value: 'my',
                    label: '我的预测'
                }, {
                    value: 'all',
                    label: '全部预测'
                }],
                yctype: [{
                    value: '2',
                    label: '待审核'
                }, {
                    value: '3',
                    label: '审核通过'
                }, {
                    value: '5',
                    label: '撤单审核中'
                }, {
                    value: '6',
                    label: '已撤单'
                }, {
                    value: '7',
                    label: '修改审核中'
                }],
                multipleSelection: [],
                tableData: [],
                userRole: [],
                // zcData:[],
                a: '',
                b: '',
                loadFlag: '',
                timeValue1: '',
                timeValue2: '',
                instid: '',
                showhistory: false,
                q: {
                    idlist: [],
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    forecastStatus:'',
                    isDel: '',
                    flag: '2',
					id: '',
					country: '',
					cdateBegin: '',
					cdateEnd: '',
					deliveryDateBegin: '',
					deliveryDateEnd: '',
					isSpecific: '',
					lockStatus: '',
					cpdlCode: '',
					cuname: '',
					proModel: '',
					proCode: '',
					ycrcode: '',
					protype: '',
					isCg: '',
					orderStatus: '',
					orderId: '',
					orderSap: ''
                },
            }
        },
        mounted() {
            this.query();
        },
        created() {
            if (this.$store.getters.hasRole('swyl_shengchan')) {
                this.q.isDel = '1';
                this.q.forecastStatus = '3';
            }
            if (this.$store.getters.hasRole('swyl_admin') || this.$store.getters.hasRole('swyl_waixiaogly')) {
                this.a = 1;
            }
            if (this.$store.getters.hasRole('swyl_wxcggly') || this.$store.getters.hasRole('swyl_admin')) {
                this.b = 1;
            }
        },
		activated(){
			this.handleFilter();
		},
		beforeRouteLeave(to, from, next) {
			from.meta.keepAlive = false;
			next();
		},
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            genzongLiuch(v) {
                console.log(v.instId);
                this.instid = v.instId;
                this.showhistory = true;
            },
            revise(v) {
				this.$msg.confirm("确认修改?", () => {
					ss.waixiao.checkRevise(v).then(rd => {
						if (rd.f == true) {
							this.$router.push({path: "/yuce/wxyuceRevise", query: {id: v}});
						} else {
							this.$msg.msge(rd.msg);
						}
					})
				})
            },
            withdraw(v) {
                this.$msg.confirm("确认撤单?", () => {
                    ss.waixiao.withdraw(v).then(rd => {
                        if (rd.f == true) {
                            this.$msg.msgs(rd.msg);
                        } else {
                            this.$msg.msge(rd.msg);
                        }
                        this.query();
                    })
                })
            },
            reviseInventory() {
                this.$msg.confirm("确认修改?", () => {
                    ss.waixiao.reviseInventory(this.tableData).then(rd => {
                        if (rd.f == true) {
                            this.$msg.msgs(rd.msg);
                        } else {
                            this.$msg.msge(rd.msg);
                        }
                    })
                });
            },
            // createOrder(ycid) {
            //     this.$router.push({path: '/dingd/orderCreateYC', query: {ycId: ycid}});
            // },
            createOrder() {
                if (this.multipleSelection && this.multipleSelection.length > 0) {
                    var yc = [];
                    for (var i = 0; i < this.multipleSelection.length; i++) {
                        if (this.multipleSelection[i].protype == 'OEM' && this.multipleSelection[i].forecastStatus == 3) {
                            yc.push(this.multipleSelection[i].id);
                        } else if (this.multipleSelection[i].protype != 'OEM') {
                            this.$msg.msge("只有OEM产品才可创建采购订单！");
                            return false;
                        } else if (this.multipleSelection[i].forecastStatus != 3) {
                            this.$msg.msge("必须是审核通过的数据才可创建采购订单！");
                            return false;
                        }
                    }
                    var yd = [];
                    for (var i = 0; i < this.multipleSelection.length; i++) {
                        yd.push(this.multipleSelection[i].id);
                    }
                    ss.waixiao.isCreateCg(yd).then(rd => {
                        if (rd.f == false) {
                            this.$msg.msge(rd.msg);
                        } else {
                            this.$router.push('/dingd/orderCreateYC');
                            JSON.stringify(yc)
                            sessionStorage.setItem('ycId',yc);
                        }
                    })
                } else {
                    this.$msg.msg("请至少选择一条预测数据！");
                }
            },
            showRow(id) {
                this.$router.push({path: "/yuce/yuceOccupy", query: {id: id, status: 1}})
            },
            timeSelect1() {
                if (this.timeValue1) {
                    this.q.cdateBegin = this.timeValue1[0];
                    this.q.cdateEnd = this.timeValue1[1];
                } else {
                    this.q.cdateBegin = '';
                    this.q.cdateEnd = '';
                }
            },
            timeSelect2() {
                if (this.timeValue2) {
                    this.q.deliveryDateBegin = this.timeValue2[0];
                    this.q.deliveryDateEnd = this.timeValue2[1];
                } else {
                    this.q.deliveryDateBegin = '';
                    this.q.deliveryDateEnd = '';
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            resetData() {
                this.q.id = '';
                this.q.country = '';
                this.timeValue1 = '';
                this.q.cdateBegin = '';
                this.q.cdateEnd = '';
                this.timeValue2 = '';
                this.q.deliveryDateBegin = '';
                this.q.deliveryDateEnd = '';
                this.q.isSpecific = '';
                this.q.forecastStatus = '';
                this.q.lockStatus = '';
                this.q.cpdlCode = '';
                this.q.cuname = '';
                this.q.proModel = '';
                this.q.proCode = '';
                this.q.ycrcode = '';
                this.q.protype = '';
                this.q.isDel = '';
                this.q.isCg = '';
                this.q.orderId = '';
                this.q.orderSap = '';
                this.q.pageSize = 10;
                this.q.pageNo = 1;
                this.query();
            },
            //明细导出
            exportExcel() {
                this.q.idlist = [];
                if (this.multipleSelection.length > 0) {
                    this.multipleSelection.forEach(element => {
                        this.q.idlist.push(element.id);
                    });
                }
                updownfile.down("/api/swyl/v1/demo/viewWxycReport/downloadreportExcel", this.q, "post", 'data');
            },
            query() {
                ss.waixiao.showReportPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
					if (this.tableData && this.tableData.length > 0) {
						for (var i = 0; i < this.tableData.length; i++) {
							this.tableData[i]['showXG'] = false;
							if (this._user.usercode == this.tableData[i].cucode && this.tableData[i].forecastStatus == 3) {
								if (this.tableData[i].protype == '自产' && this.tableData[i].schedulingStatus != '已排产') {
									this.tableData[i].showXG = true;
								}
								if (this.tableData[i].protype == 'OEM' && (!this.tableData[i].cgCode || this.tableData[i].cgCode == '')) {
									this.tableData[i].showXG = true;
								}
							}
						}
					}
                })
            },
            handleFilter() {
                this.q.pageNo = 1;
				this.query();
                // ss.waixiao.showReportPage(this.q).then(rd => {
                //     this.q.total = rd.total;
                //     this.tableData = rd.records;
				// 	if (this.tableData && this.tableData.length > 0) {
				// 		for (var i = 0; i < this.tableData.length; i++) {
				// 			this.tableData[i]['showXG'] = false;
				// 			if (this._user.usercode == this.tableData[i].cucode && this.tableData[i].forecastStatus == 3
				// 					&& this.tableData[i].proNumber == this.tableData[i].useNumber) {
				// 				if (this.tableData[i].protype == '自产' && this.tableData[i].schedulingStatus != '已排产') {
				// 					this.tableData[i].showXG = true;
				// 				}
				// 				if (this.tableData[i].protype == 'OEM' && (!this.tableData[i].cgCode || this.tableData[i].cgCode == '')) {
				// 					this.tableData[i].showXG = true;
				// 				}
				// 			}
				// 		}
				// 	}
                // })
            },
            handlelist() {
				this.query();
                // ss.waixiao.showReportPage(this.q).then(rd => {
                //     this.q.total = rd.total;
                //     this.tableData = rd.records;
				// 	if (this.tableData && this.tableData.length > 0) {
				// 		for (var i = 0; i < this.tableData.length; i++) {
				// 			this.tableData[i]['showXG'] = false;
				// 			if (this._user.usercode == this.tableData[i].cucode && this.tableData[i].forecastStatus == 3
				// 					&& this.tableData[i].proNumber == this.tableData[i].useNumber) {
				// 				if (this.tableData[i].protype == '自产' && this.tableData[i].schedulingStatus != '已排产') {
				// 					this.tableData[i].showXG = true;
				// 				}
				// 				if (this.tableData[i].protype == 'OEM' && (!this.tableData[i].cgCode || this.tableData[i].cgCode == '')) {
				// 					this.tableData[i].showXG = true;
				// 				}
				// 			}
				// 		}
				// 	}
                // })
            },
            // gettabledata(xs){
            //     xs.forEach((item, index) => {
            //         ss.waixiao.selectAllPlan(item.id).then(rd => {
            //
            //             item.shengchanId = rd.aufnr;
            //             item.orderStatus = rd.orderStatus;
            //             item.finishTime = rd.gstrp;
            //         })
            //     })
            //     setTimeout(res=>{
            //         this.tableData = xs;
            //         console.log(this.tableData,"///////////////////");
            //     },1000)
            // },
            renovate() {
                this.$router.push({path: "/yuce/wxhuizong"});
            },
			handleTiaozhuan(){
				this.$router.push({path: "/yuce/wxhuizong1"});
			}
        }
    }
</script>
<style>
   /* .ljjclassdate .el-date-editor .el-range-separator {
        width: 8%;
    } */
	.ljjtableinputss{
		margin-top: 0.03rem;
	}
    .ljjtableinputss .el-input__inner {
        padding: 0.01rem 0.1rem;
    }
	.ljjinputpadding .el-table tbody td .cell{
		padding: 0.05rem 0.1rem;
	}
	/* .h-formBorder .timeselect .el-form-item__content {
	    line-height: 0.2rem;
	} */
	
	.h-formBorder .timeselect .el-date-editor .el-range-separator {
	    width: 8%;
	    line-height: 0.3rem;
	}
	
	.h-formBorder .timeselect .el-input__inner {
	    padding-right: 0.1rem;
	}
</style>
